import React,{useState,useEffect} from 'react'
import { Container,Col,Row } from 'react-bootstrap'
import SearchBooking from '../SearchBooking/SearchBooking'
import logo from './../../assets/images/logo.png'
import { IoMdBus } from 'react-icons/io';
import { BiLoaderAlt } from 'react-icons/bi';
import './TaxiServiceAccross.css'
const TaxiServiceAccross = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // simulate an async action
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []); // pass an empty array to only run this effect once



  return (
    <>
     <div>
      {isLoading ? (
        <div className='mainContainerLoader'>
            <img src={logo} 
              className="logoAlertImg"
            
            />

            {/* <div className='alertTxt'>Please wait .....</div> */}

            <div className='topLoaderIconsAlert'>
            <IoMdBus className='busIcon'/>
            <BiLoaderAlt className='loaderIconAlert'/>

            </div>

        
          
          
          </div>
      ) : (
        <></>
      )}
    </div>
    <div className='mainContainerTexiSerTop'>
    <Container>
          <Row className='topRowTaxiServ'>
            <Col md={7} sm={12} xs={12}>
              <div>
                <div>
                  <h1
                  className='headerCompHeading'
                    style={{
                      color: "#fff",
                      fontSize: "38px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      lineHeight: "60px",
                      fontFamily: "Poppins, sans-serif",
                      marginBottom: ".5rem",
                      textDecoration: "none",
                      marginTop: "0",
                    }}
                  >
YOUR CHAUFFER SERVICE
                </h1>

                  <p
                    style={{
                      lineHeight: "28px",
                      letterSpacing: ".5px",
                      fontFamily: "Poppins, sans-serif",
                      color: "#fff",
                      textDecoration: "none",
                      marginBottom: "1rem",
                    }}
                  >
Execlane Chauffeurs provide chauffeur services to our clients in and around
Manchester and North England. We specialise in business and leisure transfer. We aim to deliver quality transport service and be part of your success story. Be our GUEST and enjoy the comfort.                  </p>

                  {/* <a
                    href="#"
                    style={{
                      color: "#000",
                      background: "#fff",
                      fontWeight: "660",
                      padding: "9px 21px",
                      textDecoration: "none",
                      display: "block",
                      width: "150px",
                      textAlign: "center",
                      marginTop: "25px",
                      height: "50px",
                      lineHeight: "33px",
                      fontSize: "18px",
                      borderRadius:"10px"
                    }}
                  >
                    {" "}
                    Quote Now{" "}
                  </a> */}
                </div>
              </div>
            </Col>
            <Col lg={5} md={12} sm={12} xs={12}>
              <div style={{ color: "#fff", borderRadius: "16px 16px 0 0" }}>
                
             
                  <SearchBooking/>
               
              </div>
            </Col>
          </Row>
        </Container>
        </div>
    </>
  )
}

export default TaxiServiceAccross